import { render, staticRenderFns } from "./SideComments.vue?vue&type=template&id=172c3fe9&scoped=true&"
import script from "./SideComments.vue?vue&type=script&lang=js&"
export * from "./SideComments.vue?vue&type=script&lang=js&"
import style0 from "./SideComments.vue?vue&type=style&index=0&id=172c3fe9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172c3fe9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
